.topTerpenesContainer {
  margin-top: 16px;
}

.terpeneBarContainer {
  margin-top: 16px;
  flex-wrap: nowrap;
  width: 100%;
  gap: 16px;
}

@media (--reefer-media-tablet-min) {
  .topTerpenesContainer {
    margin-top: 24px;
  }

  .terpeneBarContainer {
    margin-top: 24px;
  }
}
